import React from 'react';
import backgroundImg from '../pages/assets/img/codigoEtica.jpg'
import createHistory from 'history/createBrowserHistory';
import { NavbarMain } from './NavbarMain';
// Listado provisto por Farmalink, en el orden en que se muestra
import emisores from '../data/emisores.json';


export default class PagEmisores extends React.Component{

    componentDidMount(){
        const history = createHistory();
        const previousHash = history.location.hash;
        document.getElementById("map-farma").style.display = 'none';
        document.getElementById("about").style.display = 'block';
        this.backListener = history.listen((location,action) => {
          if(action === 'POP' && location.hash !== previousHash){
            window.location.reload();
          }
        })
    }

    componentWillUnmount(){
        document.getElementById("map-farma").style.display = 'inline-block';
        this.backListener();
    }

    render(){
        return(
        <div>
            <header>
                <NavbarMain home={false}/>
            </header>
            <main role="main">
                <section id="faq" class="intro-section-subpage">
                    <div class="subpageFarma" style={{backgroundImage: `url(${backgroundImg})`}}></div>
                    <div class="intro-subpage">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="main-heading">
                                        <h4>RECETA ELECTRÓNICA</h4>
                                        <h1>Emisores homologados</h1>
                                    </div>
                                </div>

                                <div class="col-12 content">
                                    <div class="row justify-content-md-center">
                                        <div class="col col-lg-10">
                                            <p>Ante la necesidad de un ambiente con múltiples sistemas emisores, para múltiples clientes, impulsado por la nueva ley y disposiciones en materia de receta electrónica,&nbsp;Farmalink desarrolla un proceso estandarizado e integrado a la validación/dispensa en farmacias.</p>
                                            <p>A fin de proveer mayor seguridad sobre el origen de la prescripción y el circuito de dispensa, y de ofrecer a afiliados, médicos, farmacias y entidades de salud un sistema seguro y confiable para validar recetas, hemos homologado los siguientes sistemas de emisión de recetas electrónicas:</p>
                                            <br/>
                                            <div class="list-columns">
                                                {emisores.map((nombre) => (
                                                    <div class="list-public list-compact" key={nombre}>
                                                        <div class="row">
                                                            <div class="col-12 title">{nombre}</div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
        );
    }
}
